import { CustomColumnGridConfig } from '../types'
import { formatLossPercent } from '@/utils/analyticsFormat'
import { formatThreeDecimalsCell } from '@/utils/cellFormat'

const formatDate = (s?: string) => {
  if (!s) return '-'
  const d = new Date(s)
  if (isNaN(d.getTime())) return s
  return d.toLocaleDateString('he-IL')
}

const columnsConfig: CustomColumnGridConfig[] = [
  {
    field: 'startDate',
    flex: 1.4,
    headerName: 'תאריך',
    disableAggregation: true,
    renderCell: params => {
      const start = formatDate(params.row?.startDate)
      const end = formatDate(params.row?.endDate)
      if (!params.row?.endDate || start === end) return start
      return `${start} - ${end}`
    },
    filter: { type: 'search' },
    filterable: true,
  },
  {
    field: 'suppliers',
    flex: 1,
    headerName: 'מספקים',
    type: 'number',
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'consumers',
    flex: 1,
    headerName: 'צרכנים',
    type: 'number',
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'lossPercent',
    flex: 1,
    headerName: 'אחוז פחת',
    type: 'number',
    renderCell: params => formatLossPercent(params.value),
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'shared',
    flex: 1,
    headerName: 'צריכה משותפת לצרכן',
    type: 'number',
    format: formatThreeDecimalsCell,
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'supplyNight',
    flex: 1,
    headerName: 'ס. לילה',
    type: 'number',
    format: formatThreeDecimalsCell,
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'consumptionNight',
    flex: 1,
    headerName: 'נ. לילה',
    type: 'number',
    format: formatThreeDecimalsCell,
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'supply',
    flex: 1,
    headerName: 'סופק',
    type: 'number',
    format: formatThreeDecimalsCell,
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'consumption',
    flex: 1,
    headerName: 'נצרך',
    type: 'number',
    format: formatThreeDecimalsCell,
    filter: { type: 'aggregated' },
    filterable: true,
  },
  {
    field: 'loss',
    flex: 1,
    headerName: 'הפרש מדידה',
    type: 'number',
    format: formatThreeDecimalsCell,
    filter: { type: 'aggregated' },
    filterable: true,
  },
]

export default columnsConfig
